export default __webpack_public_path__ + "static/media/certification1.3ca51b8d.jpg";